<template>
  <table class="tbl select-tbl">
    <colgroup>
      <col width="110px">
      <col width="21%">
      <col width="19%">
      <col width="22%">
      <col width="22%">
      <col width="100px">
    </colgroup>
    <thead>
    <tr>
      <th>{{$t('formLabel.category')}}</th><!--항목-->
      <th>{{$t('formLabel.manufacturer')}}</th><!--제조사-->
      <th>{{$t('formLabel.modelName')}}</th><!--모델명-->
      <th>{{$t('formLabel.serialNo')}}</th><!--시리얼 번호-->
      <th>{{$t('formLabel.etc')}}</th><!--비고-->
      <th></th>
    </tr>
    </thead>
    <tbody>

    <td style="overflow:inherit">
      <dropdown v-model="assetItem.assetCode" displayName="assetStr" valueName="assetCode" :datasource="assetData" :isSelectionFirstData="true" title="" :isAuto="true" />
    </td>
    <td>
      <ValidationProvider rules="min:1" v-slot="{ errors }">
        <input type="text" :name="$t('formLabel.manufacturer')" class="form-control form-control-danger" v-model="assetItem.assetManufacturer">
        <span class="input-error">{{ errors[0] }}</span>
      </ValidationProvider>
      <!--p class="error" v-show="errors.has('email')">
        {{errors.first('phone')}}
      </p-->
    </td>
    <td>

      <input type="text" :name="$t('formLabel.modelName')" class="form-control form-control-danger" v-model="assetItem.assetModel">
    </td>
    <td>
      <input type="text" :name="$t('formLabel.serialNo')" class="form-control form-control-danger" v-model="assetItem.assetSerial">
    </td>
    <td>
      <input type="text" :name="$t('formLabel.etc')" class="form-control form-control-danger" v-model="assetItem.assetMemo">
    </td>
    <td><button class="btn btn-md light-blue" @click="addAsset()" :disabled="addButtonDisable"><i class="icon-plus mr-5"></i>{{$t('button.add')}}</button></td>


    <tr v-for="(asset, index) in assetList" :key="index" >
      <td>{{asset.assetStr}}</td>
      <td>{{asset.assetManufacturer}}</td>
      <td>{{asset.assetModel}}</td>
      <td>{{asset.assetSerial}}</td>
      <td>{{asset.assetMemo}}</td>
      <td style="text-align:center"><i class="icon-recyle" @click="removeAsset(asset)"></i></td>
    </tr>

    </tbody>
  </table>
</template>

<script>
  import Dropdown from '@/components/Dropdown.vue';

  export default {

    props: {
      assetList: { type: Array, default: function(){ return []}}
    },

    data() {
      return {
        assetItem: {
        },
        selectAssetType: null
      }
    },
    components: { Dropdown },
    computed: {
      assetData() {
        var result = null;
        if(this.$store.getters['dropdown/dataprovider']){

          result = this.$store.getters['dropdown/dataprovider'].asset;
        }
        return result;
      },
      addButtonDisable(){
        var result = true;
        if(this.assetItem.assetManufacturer && this.assetItem.assetModel && this.assetItem.assetSerial) {
          result = false;
        }
        return result;
      }

    },
    mounted(){

    },
    methods: {
      addAsset(){
        var asset = Object.assign({id: this.uuidv4()}, this.assetItem);
        // asset.assetStr = this.assetData[asset.assetCode].assetStr;
        asset.assetStr = this.assetData.filter( (item) => {
          console.log(item);
          console.log(asset);
          return item.assetCode == asset.assetCode;
        })[0].assetStr;
        this.assetItem = {
          assetCode: asset.assetCode
        };
        this.assetList.push(asset);
        this.$emit('input', this.assetList);
      },

      removeAsset(asset){

        this.assetList = _.reject(this.assetList , x => x.id === asset.id);
      },
    }
  }
</script>

<style>

</style>
